import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Flex, Text } from '@radix-ui/themes';

import RadixDialog from '../../../shared/RadixDialog';
import DatePicker from '../../../shared/DatePicker/DatePicker.jsx';
import styles from './ScheduleModal.module.css';

export const SaveDraftButton = ({ open, onClose, onSave }) => {
  const { t } = useTranslation('broadcasts');
  const [selectedDate, setSelectedDate] = useState(null);
  const [error, setError] = useState('');

  const handleDateChange = dates => {
    if (dates && dates.length > 0) {
      setSelectedDate(dates[0]);
      setError('');
    }
  };

  const handleSave = () => {
    if (!selectedDate) {
      setError(t('scheduling.dateRequired'));
      return;
    }

    onSave(selectedDate);
    handleClose();
  };

  const handleClose = () => {
    setSelectedDate(null);
    setError('');
    onClose();
  };

  return (
    <RadixDialog
      isOpen={open}
      onClose={handleClose}
      title={t('saveAsDraft')}
      zIndex={1400}
    >
      <Flex direction="column" gap="3" className={styles.content}>
        <Text as="p" size="2" color="gray">
          {t('saveAsDraftWithDate')}
        </Text>

        <div className={styles.calendarWrapper}>
          <DatePicker
            value={selectedDate}
            onChange={handleDateChange}
            minDate="today"
            mode="single"
            size={1}
          />
        </div>

        {error && (
          <Text size="2" className={styles.errorMessage}>
            {error}
          </Text>
        )}

        <Flex gap="3" justify="end">
          <Button variant="outline" size="3" onClick={handleClose}>
            {t('scheduling.cancel')}
          </Button>
          <Button variant="solid" size="3" onClick={handleSave}>
            {t('saveAsDraft')}
          </Button>
        </Flex>
      </Flex>
    </RadixDialog>
  );
};
